import {action} from 'mobx';

import BaseStore from "./BaseStore";
import TransferModel from "../models/TransferModel";

class TransferStore extends BaseStore {
    constructor(transportLayer) {
        super(TransferModel, transportLayer);
    }

    @action
    updateStatus = (id, newStatus) => {
        this.items = this.items.map(item => {
            if(+item.id === +id) {
                const {status, ...others} = item;

                return {...others, status: newStatus};
            } else {
                return item;
            }
        })
    }
}

export default TransferStore;



// WEBPACK FOOTER //
// ./src/stores/TransferStore.js